// The customer's own note on a Lao eTax document (`@DocData.remark`).
//
// This is NOT the gateway's "remarks" field. That one is ED.IN.Subject, which
// the Lao mapper sends to the MoF gateway and the four Lao PDF templates print.
// This note goes nowhere: it is stored on the document, shown in the documents
// table, and that is the whole of it — the same contract `@DocData.policyNo`
// already has (see the schema text in functions/src/api/apiLaoEtaxV1.js: "Stored
// with the document ... not sent to the tax authority").
//
// Two consequences worth keeping in mind before editing this file:
//
//   * No parenthesis stripping. The mapper replaces ( ) with spaces because the
//     gateway silently marks an invoice Invalid when it meets them. Nothing here
//     reaches the gateway, so applying that rule would mangle the customer's own
//     words for a reason that does not apply to them.
//   * No lock after filing. A note that is never filed stays useful — annotating
//     an already-issued invoice is the main thing people want it for — so unlike
//     the send flow there is no status that freezes this field.
//
// The logic lives out here rather than in the component because a .vue file in
// this app cannot be unit-tested: vue-jest 3.0.7 fails on this app's templates.
// See tests/unit/laoApprovedQuery.spec.js for the longer version of that story.

// Our own cap. There is nothing to mirror — no gateway contract, no PDF layout
// to overflow — so this exists only to keep one free-text field from growing
// without bound in a document that is read on every page of the table. 500
// characters is a few sentences, which is what a note on an invoice is for.
export const LAO_REMARK_MAX_LENGTH = 500;

function str(value) {
  return String(value === null || typeof value === "undefined" ? "" : value);
}

// Trim only. Interior spacing, line breaks and punctuation are the customer's
// business — see the file header on why nothing else is touched.
export function normalizeLaoRemark(value) {
  return str(value).trim();
}

// "" when the value may be saved. Empty is valid on purpose: clearing the note
// is a normal edit, and an absent `@DocData.remark` is how a document with no
// note already looks.
export function laoRemarkError(value) {
  const clean = normalizeLaoRemark(value);
  if (clean.length > LAO_REMARK_MAX_LENGTH) {
    return (
      "remark ยาวเกิน " +
      LAO_REMARK_MAX_LENGTH +
      " ตัวอักษร (ตอนนี้ " +
      clean.length +
      ")"
    );
  }
  return "";
}

// What the table cell shows. The column is one line among many, so a long note
// is cut with an ellipsis and the full text goes in the cell's tooltip.
export function laoRemarkPreview(value, limit) {
  const clean = normalizeLaoRemark(value).replace(/\s+/g, " ");
  const max = typeof limit === "number" && limit > 0 ? limit : 40;
  if (clean.length <= max) return clean;
  return clean.slice(0, max - 1) + "…";
}
